import {SuiModalComponent, SuiModalModule} from '@angular-ex/semantic-ui';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';

import {PopulatedUser} from '../../../core/models/users/users.model';
import {ToastService} from '../../../core/services/toast/toast.service';
import {UsersService} from '../../../core/services/users/users.service';
import {
  UserNewsletterFormComponent,
  UserNewsletterFormValues,
} from '../../forms/user-newsletter-form/user-newsletter-form.component';
import {UserFormValues, UserProfileFormComponent} from '../../forms/user-profile-form/user-profile-form.component';

@Component({
  selector: 'app-register-modal',
  templateUrl: './register-modal.component.html',
  styleUrls: ['./register-modal.component.css'],
  imports: [
    SuiModalModule,
    UserProfileFormComponent,
    UserNewsletterFormComponent,
  ],
})
export class RegisterModalComponent implements OnInit {
  user!: PopulatedUser<'institution'>;

  constructor(
    protected router: Router,
    protected keycloakService: KeycloakService,
    private usersService: UsersService,
    private toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.usersService.getCurrentUser(['institution'], false).subscribe(user => {
      this.user = user;
      this.user.abonnement ||= {
        email: user.email,
        topics: [],
        subjectAreas: [],
        days: [],
      };
      // We must set this because the field is hidden in the newsletter form and it would be invalid otherwise.
      this.user.abonnement.email ||= user.email;
    });
  }

  finishRegistration(profile: UserFormValues, newsletter: UserNewsletterFormValues, modal: SuiModalComponent<any, any>) {
    const {receiveInternalMessages, ...rest} = newsletter;
    this.usersService.updateOne(this.user._id, {
      ...profile,
      receiveInternalMessages,
      abonnement: {
        ...this.user.abonnement,
        ...rest,
        email: this.user.email,
        // last mail send one week ago
        lastMailSend: new Date(Date.now() - 7 * 24 * 60 * 60000),
      },
    }).subscribe(() => {
      this.toastService.success(
        $localize`:@@app-subscribe-success-title:Newsletter abonniert`,
        $localize`:@@app-subscribe-message:Der FIT-Newsletter wurde erfolgreich abonniert und wird Ihnen an den gewünschten Tagen zugestellt. Natürlich können Sie den Newsletter auch jederzeit abbestellen.`)
      modal.approve(true);
    });
  }
}
